import React from 'react';
import AppContextPropsType from '../../shared/models/AppContextPropsType';
import defaultConfig from '../../shared/configs/defaultConfig';

export default React.createContext<AppContextPropsType>(defaultConfig);
